import { type ReactElement } from 'react';
import { Box, Button, Text } from '@citibox-panel/ui';

export interface ReadErrorStripProps {
  message: string;
  onRetry: () => void;
}

// How a failed read degrades: a neutral strip, never an alert. A card that could not read is not a
// failure to interrupt over, it is a question that has not been answered yet — and the answer is one
// click away. It never carries the server's own `message`/`detail`: the text is fixed panel copy.
//
// The border is `divider` rather than a semantic colour for the same reason: what separates the
// strip from the card it sits in is that it exists, not that it shouts.
//
// The message is a prop because the cards differ — the counter names the count it could not load,
// the lookup the location it could not read — while the shape and the retry are the same in both.
export function ReadErrorStrip({ message, onRetry }: ReadErrorStripProps): ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        pl: 2,
        pr: 1,
        py: 1,
      }}
    >
      <Text variant="body2">{message}</Text>
      <Button variant="text" onClick={onRetry}>
        Reintentar
      </Button>
    </Box>
  );
}
